/** End credits: fictional crew list. Keys live in home.film.credits.lines. */
export const FILM_CREDIT_LINE_IDS = [
  "written",
  "breakdown",
  "schedule",
  "budget",
  "calls",
] as const;

/** Crew call rows (content/role-paths ids) with fictional call times. */
export const FILM_CALL_TIMES = {
  writer: "07:00",
  studio: "06:30",
  enterprise: "06:00",
} as const;

/** Closed set items, in reading order. */
export const FILM_CLOSED_SET_ITEMS = [
  "noTraining",
  "encryption",
  "shareLinks",
  "rbac",
  "sso",
  "audit",
] as const;
